export const heroImages = {
  home: '/assets/img/bg-banner.jpg',
  lp: '/assets/img/bg-banner.jpg',
  about: 'https://images.unsplash.com/photo-1758691737492-48e8fdd336f7?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
  contact: '/assets/img/bg-cta.jpg',
  privacy: 'https://images.unsplash.com/photo-1752697589000-9819ed4fc30c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
  terms: 'https://images.unsplash.com/photo-1752697589000-9819ed4fc30c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
};

export const serviceHeroImages = {
  trademark: '/assets/img/bg-banner.jpg',
  'company-formation': 'https://images.unsplash.com/photo-1772413438614-3d4582783392?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
  copyright: 'https://images.unsplash.com/photo-1593444285553-28163240e3f1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
  patent: 'https://images.unsplash.com/photo-1764106813759-9ef7bf42a0af?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
  legal: 'https://images.unsplash.com/photo-1758519288480-1489c17b1519?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
  additional: 'https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1920',
};
